import type { ModalComponent } from "./modal-builder";

export type ModalWithOptionalDeduplicationKey<T> = T | { modal: T; deduplicationKey: string };

export const resolveModalId = (modal: ModalWithOptionalDeduplicationKey<ModalComponent<never>>) => {
  if ("deduplicationKey" in modal) {
    return `${modal.modal.modalId}-${modal.deduplicationKey}`;
  }

  return modal.modalId;
};
